// Client-side validation. One source of truth used both for button-disabled
// state in each step and for the advance/submit guards in Survey.tsx. The
// server re-validates with zod — these are UX helpers, not the security
// boundary.

import type { SurveyState } from "./types.js";

// Deliberately permissive — the server's zod uses `.email()` which is stricter.
// This just catches obvious typos so the Submit button doesn't light up on "foo".
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Signup (the required step). Mirrors the old isStep3Valid.
export function isSignupValid(s: SurveyState): boolean {
  if (!s.parentName.trim()) return false;
  if (!EMAIL_RE.test(s.parentEmail.trim())) return false;
  if (!s.city) return false;
  if (!s.consent) return false;
  if (s.athletes.length === 0) return false;
  if (s.athletes.some((a) => !a.ageBand || !a.gender)) return false;
  return true;
}

// Optional research — family bucket + reasons.
export function isResearchBucketValid(s: SurveyState): boolean {
  return s.bucket !== null && s.reasons.length > 0;
}

// Optional research — price, sibling, season.
export function isResearchPricesValid(s: SurveyState): boolean {
  return (
    s.priceFsl !== null &&
    s.priceCategory !== null &&
    s.sibling !== null &&
    s.season !== null
  );
}
